/* eslint-disable  */
/* eslint-disable no-console */
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useContext, useEffect, useState } from 'react';
import { ReactComponent as SortdownIcon } from '../../../assets/images/sort-down-icon.svg';
import { ReactComponent as SortupIcon } from '../../../assets/images/sort-up-icon.svg';
import { ReactComponent as ItemAddition } from '../../../assets/images/ItemAddition.svg';
import InfiniteScroll from 'react-infinite-scroll-component';
import { AgreementContext } from '../../../context/AgreementContext';
import { ReactComponent as Info } from '../../../assets/images/info-tooltip.svg';
import {
  Grid,
  RACTable,
  RACTableCell,
  RACTableRow,
  CircularProgress,
  RACTooltip,
} from '@rentacenter/racstrap';
import { fixedGridStyles } from '../../../JSstyles/fixedGridStyles';
import { useHistory } from 'react-router-dom';
import { removeColumnHeader } from '../../Shared/removeColumnHeader';
import { FeatureFlagContext } from '../../../context/FeatureFlagContext';
import { useTranslation } from 'react-i18next';
import ExceptionController from './exceptionController';
import { agreementGlobalStyles } from '../../../JSstyles/agreementGlobalStyles';
import { handleItemRestriction } from '../../../utils/itemRestrictionUtils';

export interface dynamicProps {
  items: any;
  orderBy: string;
  order: string;

  handleActionType: (
    value: any,
    index: any,
    status: any,
    invNumber: any,
    inventoryPriceId: any
  ) => void;
  throwStyle: any;
}
export interface columns {
  columnId: string;
  sortOrder: string;
  columnTitle: string;
  IsSorted: boolean;
  IsSortable: boolean;
  columnType?: 'link';
  handleColumnClick?: () => void;
  subColumns?: columns[];
}
const sortDirection = {
  ASC: 'asc',
  DESC: 'desc',
};

export interface IDynamicPageState {
  gridValues: [];
  gridColumn: columns[] | [];
}

const packagePriceColumns: columns[] = [
  {
    columnId: 'inventoryNumber',
    sortOrder: sortDirection.ASC,
    columnTitle: 'Item #',
    IsSorted: true,
    columnType: 'link',
    IsSortable: true,
  },
  {
    columnId: 'departmentsEn',
    sortOrder: sortDirection.DESC,
    columnTitle: 'Department',
    IsSorted: false,
    IsSortable: true,
  },
  {
    columnId: 'subDepartmentsEn',
    sortOrder: sortDirection.DESC,
    columnTitle: 'Sub Department',
    IsSorted: false,
    IsSortable: true,
  },
  {
    columnId: 'brandName',
    sortOrder: sortDirection.DESC,
    columnTitle: 'Brand',
    IsSorted: false,
    IsSortable: true,
  },
  {
    columnId: 'modelNumber',
    sortOrder: sortDirection.DESC,
    columnTitle: 'Model #',
    IsSorted: false,
    IsSortable: false,
  },
  {
    columnId: 'weeklyRate',
    sortOrder: sortDirection.DESC,
    columnTitle: 'Rate',
    IsSorted: false,
    IsSortable: true,
  },
  {
    columnId: 'weeklyTerm',
    sortOrder: sortDirection.DESC,
    columnTitle: 'Term',
    IsSorted: false,
    IsSortable: true,
  },
  {
    columnId: 'weeklyRateAddOn',
    sortOrder: sortDirection.DESC,
    columnTitle: 'Add-On Rate',
    IsSorted: false,
    IsSortable: true,
  },
  {
    columnId: 'statusEn',
    sortOrder: sortDirection.DESC,
    columnTitle: 'Status',
    IsSorted: false,
    IsSortable: true,
  },
  {
    columnId: 'conditionEn',
    sortOrder: sortDirection.DESC,
    columnTitle: 'Condition',
    IsSorted: false,
    IsSortable: true,
  },
  {
    columnId: 'remainingValue',
    sortOrder: sortDirection.DESC,
    columnTitle: 'RV',
    IsSorted: false,
    IsSortable: true,
  },
  {
    columnId: 'daysIdle',
    sortOrder: sortDirection.DESC,
    columnTitle: 'Days Idle',
    IsSorted: false,
    IsSortable: true,
  },
];

const DynamicGridComponent = (props: any) => {

  const { i18n, t } = useTranslation('rental');
  const { setSearchRes, addItemSearch, setAddItemSearch} = useContext(AgreementContext);
  const clss = agreementGlobalStyles();
  const { featureFlagDetails } = useContext(FeatureFlagContext)
  const classes = props.throwStyle;
  const fixedGridClassName = fixedGridStyles();
  const history = useHistory();

  const [gridValues, setGridValues] = useState<any[]>([]);
  const [gridColumn, setGridColumn] = useState<columns[]>([]);
  const [dept, subDept] = useState<any>();
  const { searchCriteria, isMotorcycleAdded, language, isAnyItemAdded, setMotorcycleIdentifiers, motorcycleIdentifiers } = useContext(AgreementContext);
  useEffect(() => {
    const { order, orderBy, items } = props;

    // Filter items based on MXStoreIdentifier
    let filteredItems = items;
    if (featureFlagDetails?.MXStoreIdentifier === '1') {
      filteredItems = items.filter(item => item.departmentsEn.includes("MX"));
    }

    // Sort the filtered data
    const sortedData =
      order === sortDirection.DESC
        ? filteredItems.sort((a: any, b: any) => (a[orderBy] < b[orderBy] ? -1 : 1))
        : filteredItems.sort((a: any, b: any) => (b[orderBy] < a[orderBy] ? -1 : 1));

    setGridValues(sortedData);
    setGridColumn(removeColumnHeader(packagePriceColumns, 'weeklyRateAddOn', featureFlagDetails.AddOnPricing === '1' ? 0 : 1));
  }, [props]);

  // Check if there are no records after filtering
  if (featureFlagDetails?.MXStoreIdentifier === '1' && gridValues.length === 0) {
    setSearchRes(true)
    return (
      <ExceptionController
        throwExceptionDecider="No Records"
        throwStyle={clss}
      />
    );
  }

  const truncString = (str: any, max: number, add: any) => {
    add = add || '...';
    return typeof str === 'string' && str.length > max
      ? str.substring(0, max) + add
      : str;
  };

  const sortArray = (
    columnId: string,
    index: number,
    datacolumn: any,
    dataValues: any
  ) => {
    const sortedData =
      datacolumn[index].sortOrder == sortDirection.DESC
        ? dataValues.sort((a: any, b: any) =>
          b[columnId] < a[columnId] ? -1 : 1
        )
        : dataValues.sort((a: any, b: any) =>
          a[columnId] < b[columnId] ? -1 : 1
        );
    const reorderColumns: columns[] = datacolumn;
    reorderColumns[index].sortOrder =
      reorderColumns[index].sortOrder == sortDirection.ASC
        ? sortDirection.DESC
        : sortDirection.ASC;
    reorderColumns.map((value: any, index1: number) => {
      reorderColumns[index1].IsSorted = index == index1 ? true : false;
    });
    setGridValues([...sortedData]);
    setGridColumn([...reorderColumns]);
    // setState({ gridValues: sortedData, gridColumn: reorderColumns });
  };
  const sortArrayForDollar = (
    columnId: string,
    index: number,
    datacolumn: any,
    dataValues: any
  ) => {
    const sortedData =
      datacolumn[index].sortOrder == sortDirection.DESC
        ? dataValues.sort((a: any, b: any) => b[columnId] - a[columnId])
        : dataValues.sort((a: any, b: any) => a[columnId] - b[columnId]);
    const reorderColumns: columns[] = datacolumn;
    reorderColumns[index].sortOrder =
      reorderColumns[index].sortOrder == sortDirection.ASC
        ? sortDirection.DESC
        : sortDirection.ASC;
    reorderColumns.map((value: any, index1: number) => {
      reorderColumns[index1].IsSorted = index == index1 ? true : false;
    });
    setGridValues([...sortedData]);
    setGridColumn([...reorderColumns]);
    // setState({ gridValues: sortedData, gridColumn: reorderColumns });
  };

  const renderTableHead = (dataColumns: any, dataValues: any) => {
    return (
      <>
        {gridColumn.map((value, index) => {
          return (
            <RACTableCell key={index} className={classes.bold}>
              {value.columnTitle !== 'Model #' &&
                value.columnTitle !== 'Status' ? (
                <a
                  style={{
                    color: 'black',
                    textDecoration: 'none',
                    cursor: 'pointer',
                  }}
                  id={value.columnId}
                  onClick={() =>
                    value.columnTitle !== 'Rate' && value.columnTitle !== 'RV' && value.columnId !== 'weeklyRateAddOn'
                      ? sortArray(
                        value.columnId,
                        index,
                        dataColumns,
                        dataValues
                      )
                      : sortArrayForDollar(
                        value.columnId,
                        index,
                        dataColumns,
                        dataValues
                      )
                  }
                >
                  {t(value.columnTitle) + ' '}
                  {value.IsSorted === true ? (
                    value.sortOrder == sortDirection.DESC ? (
                      <SortupIcon className={classes.ms0} />
                    ) : (
                      <SortdownIcon className={classes.ms0} />
                    )
                  ) : null}
                </a>
              ) : (
                <a
                  style={{
                    color: 'black',
                    textDecoration: 'none',
                  }}
                  id={value.columnId}
                >
                  {t(value.columnTitle) + '  '}
                </a>
              )}
            </RACTableCell>
          );
        })}
        <RACTableCell></RACTableCell>
      </>
    );
  };

  const renderTableContent = (gridBodyData: any, gridColumns: any) => {
    if (!!gridBodyData && gridBodyData.length > 0) {
      return gridBodyData.map((value: any, index1: any) => {
        const tagRate: any = value.weeklyRate.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        );
        const rv: any = value.remainingValue.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        );

        let condition: any = '';
        if (value.conditionRefCode == 'ATO') {
          condition = t('Auto');
        } else if (value.conditionRefCode == 'EXCP') {
          condition = t('Exception');
        } else if (value.conditionRefCode == 'NEW') {
          condition = t('New');
        } else {
          console.log('condition mistake', value.conditionRefCode);
          condition = value.conditionRefCode;
        }

        const { customerVerifyLevel, customerApprovalDetails } = props
        console.log("customerApprovalDetals: ", customerApprovalDetails);
        const EnableCustomerLevelItemRestriction = featureFlagDetails?.EnableCustomerLevelItemRestriction
        const productRestrictDetails = props?.customerDetails?.value?.customerLevelItemRestriction;
        const ItemRestrictionCustomerLevels = JSON.parse(featureFlagDetails?.ItemRestrictionCustomerLevels)

        let specialCaseCustomerLevel: null | string = null;
        if (customerVerifyLevel == null && customerApprovalDetails && customerApprovalDetails !== '') {
          specialCaseCustomerLevel = "LVLNULL";
        } else if (customerApprovalDetails == undefined || customerApprovalDetails == '') {
          specialCaseCustomerLevel = "NODE";
        }

        const isAllowed = handleItemRestriction({
          item: value,
          customerLevel: specialCaseCustomerLevel ?? customerVerifyLevel,
          restrictionConfig: productRestrictDetails,
          EnableCustomerLevelItemRestriction,
          ItemRestrictionCustomerLevels
        });

        return (
          <React.Fragment key={index1}>
            <RACTableRow>
              <RACTableCell>
                <a
                  className={classes.racpadLink}
                  onClick={() =>
                    history.push({
                      pathname: `/inventory/${value.inventoryNumber}/inventoryinformation`,
                    })
                  }
                >
                  {value.inventoryNumber}
                  {featureFlagDetails?.MXStoreIdentifier == '1' && motorcycleIdentifiers?.includes(value?.subDepartmentsEn) && (
                    <RACTooltip
                      placement={'top'}
                      title={
                        <div>
                          <div>{t("State Registered")}:{value?.state}</div>
                          <div>{t("License")}:{value?.license}</div>
                          <div>{t("Odometer")}:{value?.odometer}</div>
                        </div>
                      }
                      PopperProps={{
                        style: {
                          color: 'white',
                          borderRadius: '8px',
                          width: '200px',
                          fontSize: '14px',
                          boxShadow: 'none',
                          border: 'none',
                        },
                      }}
                    >
                      <span style={{ marginLeft: '5px', cursor: 'pointer', marginTop: '2px' }}>
                        <Info style={{ height: '15px', width: '20px' }} />
                      </span>
                    </RACTooltip>
                  )}
                </a>
              </RACTableCell>
              <RACTableCell
                title={
                    ((language === 'es-MX' || language === 'es-US') 
                    ? value.departmentsEs 
                    : value.departmentsEn).length > 10
                    ? (language === 'es-MX' || language === 'es-US') 
                    ? value.departmentsEs: value.departmentsEn: null
                    }
              >
                 {truncString((language == 'es-MX' || language == 'es-US') ? value.departmentsEs : value.departmentsEn , 20, '...')}
              </RACTableCell>
              <RACTableCell
                title={
                      ((language === 'es-MX' || language === 'es-US') 
                      ? value.subDepartmentsEs: value.subDepartmentsEn).length > 10
                      ? (language === 'es-MX' || language === 'es-US')? value.subDepartmentsEs 
                      : value.subDepartmentsEn: null
                      }
              >
                {truncString((language == 'es-MX' || language == 'es-US') ? value.subDepartmentsEs : value.subDepartmentsEn , 20, '...')}
              </RACTableCell>
              <RACTableCell
                title={value.brandName.length > 7 ? value.brandName : null}
              >
                {truncString(value.brandName, 7, '...')}
              </RACTableCell>
              {value.modelNumber ? (
                <RACTableCell
                  title={
                    value.modelNumber.length > 7 ? value.modelNumber : null
                  }
                >
                  {truncString(value.modelNumber, 7, '...')}
                </RACTableCell>
              ) : (
                <RACTableCell className={classes.textCenter}> - </RACTableCell>
              )}
              <RACTableCell style={{ whiteSpace: 'nowrap' }}>
                $ {tagRate}
              </RACTableCell>
              <RACTableCell>{value.weeklyTerm}</RACTableCell>
              {featureFlagDetails.AddOnPricing == '1' ? <RACTableCell>{value.weeklyRateAddOn ? `$ ${value.weeklyRateAddOn}` : '-'}</RACTableCell> : null}
              <RACTableCell
                style={{ whiteSpace: 'nowrap' }}
                title={value.statusEn.length > 15 ? value.statusEn : null}
              >
                {truncString((language == 'es-MX' || language == 'es-US')? value.statusEs : value.statusEn , 15, '...')}
              </RACTableCell>
              <RACTableCell>{truncString(t(condition), 15, '...')}</RACTableCell>
              <RACTableCell style={{ whiteSpace: 'nowrap' }}>
                $ {rv}
              </RACTableCell>
              <RACTableCell className={classes.textCenter}>
                {value.daysIdle}
              </RACTableCell>
              <RACTableCell>
                <RACTooltip
                  placement={'top'}
                  title={
                    featureFlagDetails.MXStoreIdentifier === '1' ? (
                      motorcycleIdentifiers?.includes(value?.subDepartmentsEn) && isMotorcycleAdded ? (
                        t("You can add only one motorcycle inventory at a time")
                      ) : (
                        !motorcycleIdentifiers?.includes(value?.subDepartmentsEn) && isMotorcycleAdded ? (
                          t("You can't add an item along with Motorcycle inventory")
                        ) : (
                          isAnyItemAdded && motorcycleIdentifiers?.includes(value?.subDepartmentsEn) ? (
                            t("You can't add an item along with Motorcycle inventory")
                          ) : ""
                        )
                      )
                    ) : ""
                  }

                  disableHoverListener={!isMotorcycleAdded && !(motorcycleIdentifiers?.includes(value?.subDepartmentsEn) && isAnyItemAdded)}
                  PopperProps={{
                    style: {
                      color: 'white',
                      borderRadius: '1px',
                      padding: '2px',
                    },
                  }}
                >
                  <span>
                    <RACTooltip
                    className={classes.tooltipcss}
                    classes={{
                        tooltip: classes.toolTipStyle,
                        arrow: classes.arrowStyle
                      }}
                      placement="top"
                      title={
                        !isAllowed ? "This Customer is not eligible to add this item." : ""
                      }
                    >
                      <ItemAddition
                        id={value.inventoryId}
                        onClick={(e) => {
                          const itemSearchResultArray = [...addItemSearch];
                          itemSearchResultArray.push(value);
                          setAddItemSearch(itemSearchResultArray);

                          // const itemList = Array.isArray(itemTypesEnAllowed) ? itemTypesEnAllowed : [];
                          // const itemDepartment = (value?.itemTypeEn || '').trim().toUpperCase();
                          // const isItemAllowed = itemList.some(item =>
                          //   itemDepartment?.includes((item || '').trim().toUpperCase())
                          // );
                          // const isRestrictedUser = customerVerifyLevel === '5' && !isItemAllowed;
                          if (!isAllowed) {
                            e.preventDefault();
                          } else if (isMotorcycleAdded && featureFlagDetails.MXStoreIdentifier == '1') {
                            e.preventDefault();
                          } else if (isAnyItemAdded && featureFlagDetails.MXStoreIdentifier == '1' && motorcycleIdentifiers?.includes(value?.subDepartmentsEn)) {
                            e.preventDefault();
                          } else {
                            props.handleActionType(
                              value.subDepartmentsEn,
                              value.inventoryId,
                              index1,
                              value.statusEn,
                              value.inventoryNumber,
                              value.inventoryPriceId
                            );
                          }
                        }}
                        data-testid={index1 + 'plusId'}
                        style={{
                          cursor: !isAllowed ? 'default' : 'pointer',
                          opacity: (
                            (!isAllowed) ||
                            isMotorcycleAdded && featureFlagDetails.MXStoreIdentifier == '1' ||
                            (isAnyItemAdded && featureFlagDetails.MXStoreIdentifier == '1' && motorcycleIdentifiers?.includes(value?.subDepartmentsEn))
                          ) ? 0.3 : 1,
                          pointerEvents: (
                            isMotorcycleAdded && featureFlagDetails.MXStoreIdentifier == '1' ||
                            (isAnyItemAdded && featureFlagDetails.MXStoreIdentifier == '1' && motorcycleIdentifiers?.includes(value?.subDepartmentsEn))
                          ) ? 'none' : 'auto',
                        }}
                      >
                      </ItemAddition>
                    </RACTooltip>
                  </span>
                </RACTooltip>
              </RACTableCell>
            </RACTableRow>
          </React.Fragment>
        );
      });
    }
  };
  const fetchNextData = () => {
    props.triggerSearch(searchCriteria, 'searchButtonNotClick');
  };

  return (
    <Grid className={fixedGridClassName.fixTableHead}>
      {gridValues?.length > 7 ? (
        <InfiniteScroll
          next={fetchNextData}
          dataLength={gridValues?.length}
          hasMore={props.reveiveHasMore}
          height={500}
          loader={
            props.reveivescrollLoader ? (
              <Grid className={classes.GridLoader}>
                <CircularProgress></CircularProgress>
              </Grid>
            ) : null
          }
        >
          <RACTable
            renderTableHead={() => renderTableHead(gridColumn, gridValues)}
            renderTableContent={() =>
              renderTableContent(gridValues, gridColumn)
            }
          />
        </InfiniteScroll>
      ) : (
        <RACTable
          renderTableHead={() => renderTableHead(gridColumn, gridValues)}
          renderTableContent={() => renderTableContent(gridValues, gridColumn)}
        />
      )}
    </Grid>
  );
};

export default DynamicGridComponent;
